import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 绑定 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("解绑");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("关闭");

import { computed, ref, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { getBranchBindingCustInfoList, bindingBranchCustRelation } from '@/request';
import { ElMessage } from 'element-plus';
import BindCustomerModal from './BindCustomerModal.vue';
export default {
  name: 'EditDistributorCustomerModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    data: {
      type: [Object, null],
      default: null
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const editData = computed(() => props.data);
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const table = ref();
    const form = ref({});
    const showBindCustomerModal = ref(false);

    function unBind() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      bindingBranchCustRelation({}, {
        params: {
          branchId: props.data.branchId,
          custIdList: selectRows.map(i => i.erpCustId).join(','),
          bindingFlag: 0,
          __repeat: true,
          __warn: true
        }
      }).then(data => {
        if (data.success) {
          ElMessage.success('操作成功!');
          table.value.commitProxy('query');
        }
      });
    }

    watch(() => props.modelValue, newVal => {
      if (newVal) {
        table.value.commitProxy('reload');
      }
    }, {
      flush: 'post'
    });

    function confirm() {
      visible.value = false;
      emit('success');
    }

    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        field: '全选',
        width: '50px',
        fixed: 'left'
      }, {
        field: 'erpCustId',
        title: '客户ID',
        width: '200px',
        showOverflow: true
      }, {
        field: 'custName',
        title: '客户名称',
        width: '150px',
        showOverflow: true
      }, {
        field: 'custType',
        title: '客户类型',
        width: '200px',
        showOverflow: true
      }, {
        field: 'custAddress',
        title: '详细地址',
        width: '300px',
        showOverflow: true
      }, {
        field: 'custArea',
        title: '所在区域',
        width: '200px',
        showOverflow: true
      }, {
        field: 'linkMan',
        title: '联系人',
        width: '150px',
        showOverflow: true
      }, {
        field: 'linkPhone',
        title: '联系电话',
        width: '150px',
        showOverflow: true
      }],
      proxyConfig: {
        autoLoad: false,
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getBranchBindingCustInfoList({
              page: page.currentPage,
              pageSize: page.pageSize,
              branchId: props.data.branchId,
              bindingFlag: 1
            }).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.custInfoList
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "编辑客户",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "1000px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, null, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "发货方"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(editData).branchName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(editData).branchName = $event),
                  disabled: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 10
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "所在区域"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(editData).branchArea,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(editData).branchArea = $event),
                  disabled: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
          ref_key: "table",
          ref: table
        }), {
          tools: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Connection",
            onClick: _cache[2] || (_cache[2] = $event => showBindCustomerModal.value = true)
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "danger",
            icon: "Delete",
            onClick: unBind
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        }, 16), _createVNode(BindCustomerModal, {
          data: __props.data,
          modelValue: showBindCustomerModal.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showBindCustomerModal.value = $event),
          onSuccess: _cache[4] || (_cache[4] = $event => table.value.commitProxy('reload'))
        }, null, 8, ["data", "modelValue"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};